export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24')
];

export const server_loads = [];

export const dictionary = {
		"/": [4],
		"/about-us": [5],
		"/apex/account": [6,[2]],
		"/apex/account/addresses/[addressId]/edit": [7,[2]],
		"/apex/account/purchases/history": [9,[2]],
		"/apex/account/purchases/[purchaseId]": [8,[2]],
		"/apex/account/transactions": [10,[2]],
		"/apex/add-items": [11,[2]],
		"/apex/login": [12,[2]],
		"/apex/order-confirmation": [13,[2]],
		"/apex/otp": [14,[2]],
		"/apex/plans": [15,[2,3]],
		"/apex/plans/[id]/purchase": [16,[2,3]],
		"/contact-us": [17],
		"/disclaimer": [18],
		"/faqs": [19],
		"/order-confirmation": [20],
		"/our-services": [21],
		"/privacy-policy": [22],
		"/refund-policy": [23],
		"/terms-and-conditions": [24]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	

	reroute: (() => {})
};

export { default as root } from '../root.js';